import { baConfig } from '../../config';

/**
 * Base URL for the dashboard widgets' data (cash flow, categorization
 * summary): the api-gateway, which serves
 * /orgs/:orgId/transactions/dashboards/* from api-svc (BigQuery). The
 * break-glass killswitch back to legacy transactions-query-svc lives in the
 * gateway's route config (TXN_DASHBOARDS_TARGET env), not in the UI.
 */
export function getDashboardBaseUrl(): string {
  return baConfig.gatewayUrl || '';
}
